import AxiosClient from "../AxiosClient";

// 市況価格表データ取得Api
export const postMarketPriceSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/searchInfoList", params);
}

// 市況価格表ID取得Api
export const postMarketPriceSearchIdAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/searchId", params);
}

// 市況価格表 表データ取得Api
export const postMarketPriceSearchTableInfoListAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/searchTableInfoList", params);
}

// 市況価格表履歴　出荷日期間内履歴取得Api
export const postMarketPriceSearchHistoryInShippingDates = (params) => {
  return AxiosClient.post("/api/marketPrice/searchHistoryInShippingDates", params);
}

// 市況価格表データ更新(注文編集用)Api
export const postMarketPriceUpdateInfoAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/updateInfo", params);
}

// 市況価格表履歴更新(市況価格表編集用)API
export const postMarketPriceUpdateHistoryInfoAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/updateMarketPriceHistoryInfo", params)
}

// 市況価格表　出荷日更新Api
export const postMarketPriceUpdateShippingDateInfoAPI = (params) => {
  return AxiosClient.post("/api/marketPrice/updateShippingDateInfo", params);
}
// 市況価格表　情報登録
export const insertMarketPrice = (params) => {
  const url = "/api/marketPrice/insertInfo";
  return AxiosClient.post(url, params);
};
